if (!customElements.get('blog-posts-tag-filter')) {
  customElements.define(
    'blog-posts-tag-filter',
    class extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.availableFilterGroups = [...this.querySelectorAll('.blog-posts__tag_filter__details')];
        this.curentBaseUrl = this.dataset.rootUrl || '/';
        this.sectionId = this.dataset.sectionId || '';
        this.selector = this.dataset.replaceSelector || '';
        this.updateBlogPosts = (selectedFilters) => {
          let url = this.curentBaseUrl;
          if (selectedFilters !== undefined && selectedFilters.length > 0) {
            url = `${this.curentBaseUrl}/tagged/${selectedFilters.map((filter) => encodeURIComponent(filter)).join('+')}`;
          }

          if (this.sectionId == '') {
            window.location.href = url;
          } else {
            document.querySelector(this.selector).setAttribute('aria-busy', true);
            this.fetchBlogSectionForTag(url, this.sectionId)
              .then((json) => {
                const html = json[this.sectionId];

                if (!html) {
                  throw new Error(`No HTML returned for section ${this.sectionId}`);
                }
                this.selector.split(',').forEach((selector) => {
                  this.updateBlogSectionHtml(this.sectionId, html, selector.trim());
                });
              })
              .catch((error) => {
                console.error(error);
              })
              .finally(() => {
                document.querySelector(this.selector).removeAttribute('aria-busy');
              });
          }
        };

        this.updateBlogSectionHtml = (sectionId, html, selector) => {
          const sectionHtml = new DOMParser().parseFromString(html, 'text/html');
          const sourceSelector = sectionHtml.querySelector(selector);

          if (!sourceSelector) {
            console.warn(`No selector ${selector} found in section ${sectionId}`);
            return;
          }
          const targetSelector = document.querySelector(selector);
          if (!targetSelector) {
            console.warn(`No selector ${selector} found in section ${sectionId}`);
            return;
          }
          targetSelector.innerHTML = sourceSelector.innerHTML;
        };

        this.fetchBlogSectionForTag = (url, sectionId) => {
          const requestUrl = `${url}?sections=${encodeURIComponent(this.sectionId)}`;

          return fetch(requestUrl, {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
          }).then((response) => {
            if (!response.ok) {
              throw new Error(`Section fetch failed: ${response.status}`);
            }
            return response.json();
          });
        };

        this.addEventListener('change', (e) => {
          const selectedFilters = this.availableFilterGroups
            .filter((group) => group.querySelector('input:checked') && group.querySelector('input:checked').value !== 'all')
            .map((group) => group.querySelector('input:checked').value);

          this.updateBlogPosts(selectedFilters);

          // Close the parent
          const details = e.target.closest('.blog-posts__tag_filter__details');
          details?.removeAttribute('open');

          const title = details.querySelector('.blog-posts__tag_filter__title');
          if (title.getAttribute('data-filter-title') === null) {
            title.setAttribute('data-filter-title', title.innerHTML);
          }
          title.innerHTML = e.target.value;
        });

        this.querySelector('.btn[data-action="reset-filter"]').addEventListener('click', () => {
          this.availableFilterGroups.forEach((group) => {
            const checkedElement = group.querySelector('input:checked');

            group.removeAttribute('open');
            if (checkedElement) {
              checkedElement.checked = false;
            }

            const title = group.querySelector('.blog-posts__tag_filter__title');
            if (title.getAttribute('data-filter-title') !== null) {
              title.innerHTML = title.getAttribute('data-filter-title');
            }
          });

          this.updateBlogPosts();
        });
      }
    }
  );
}
